import { InjectionKey, ComputedRef } from 'vue'

export const isExpandedSymbol: InjectionKey<ComputedRef<boolean>> =
  Symbol('isExpanded')
